import {Component, OnInit} from '@angular/core';
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";

@Component({
    selector: 'bm-creditor-camt-import-config-base',
    template: '',
    standalone: false
})
export class BmCreditorCamtImportConfigBaseComponent extends ObjectBaseModeComponent implements OnInit {

    navigationItems = [
        {
            label: 'config.detail',
            action: 'config.detail',
            tooltip: 'Konfiguration Details',
            icon: 'fa-solid fa-gears',
            toggleable: false,
            default: true
        },
        {
            label: 'config.document.types',
            action: 'config.document.types',
            tooltip: 'Zugeordnete Dokumenttypen',
            icon: 'fa-solid fa-file-lines',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }
}
